export const HEALTH_CHECK = 'HEALTH_CHECK'
